import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const paymentDateFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'payment_date_before',
    after: 'payment_date_after',
  }),
  color: FILTER_COLOR.teal,
});
